import { render, staticRenderFns } from "./FleetTrucks.vue?vue&type=template&id=5a79d708&scoped=true&"
import script from "./FleetTrucks.vue?vue&type=script&lang=js&"
export * from "./FleetTrucks.vue?vue&type=script&lang=js&"
import style0 from "./FleetTrucks.vue?vue&type=style&index=0&id=5a79d708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a79d708",
  null
  
)

export default component.exports